import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Info: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 16 16"
        sx={{ fontSize: 16, ...props.sx }}
    >
        <path d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 5 L 8 5 L 8 4 Z M 7 6 L 7 11 L 8 11 L 8 6 Z" />
    </SvgIcon>
)

export default Info
